import { makeStyles, tokens } from '@fluentui/react-components';
import { CSSProperties } from 'react';
import { customPalette } from '../theme';

export interface IJournalEntryDialogStyles {
    totalRowStyle: CSSProperties;
    gridComponentCSSClass: string;
}

const useJournalEntryGridStyles = makeStyles({
    root: {
        '&.e-grid': {
            border: 'none',
            '& .e-content .e-table': {
                borderLeft: `${tokens.strokeWidthThin} solid ${customPalette.statusCoolLightGrey}`,
            },
            '& .e-gridfooter': {
                backgroundColor: '#FFFFFF',
                '& .e-summarycontent': {
                    borderTop: `${tokens.strokeWidthThick} solid ${tokens.colorNeutralStroke1}`,
                    '& .e-table .e-summaryrow .e-summarycell': {
                        border: 'none',
                        backgroundColor: '#FFFFFF',
                    },
                },
            },
        },
        '& .e-gridheader': {
            paddingRight: '0px !important',
            '& .e-headercontent .e-table .e-columnheader .e-headercell': {
                backgroundColor: customPalette.blueC7DCE5,
            },
        },
    },
});

export const useJournalEntryDialogStyles: () => IJournalEntryDialogStyles = () => {
    const gridStyles = useJournalEntryGridStyles();
    const totalRowStyle: CSSProperties = {
        fontWeight: tokens.fontWeightSemibold,
        fontSize: tokens.fontSizeBase400,
        verticalAlign: 'top',
        lineHeight: tokens.lineHeightBase400,
    };

    return {
        gridComponentCSSClass: gridStyles.root,
        totalRowStyle,
    };
};
